import type { DataSourceAbstract } from '@lighthouse/core'
import type { SendMsgDingTalkRobotConfig, VariableTree2 } from '@lighthouse/shared'
import { getInputInnerTypeMatch, NodeFieldPreview } from '@lighthouse/shared'
import React from 'react'

import { useIsDisabledWithVersion } from '@/hooks/useIsDisabledWithVersion'

import { PersonConfig } from './PersonConfig'
import * as SC from './styles'

interface TextMsgConfigProps {
    userOption?: VariableTree2
    upstreamOptions: VariableTree2[]
    dataSourceList?: DataSourceAbstract[]
    value: SendMsgDingTalkRobotConfig
    onChange: (value: SendMsgDingTalkRobotConfig) => void
}

export const TextMsgConfig: React.FunctionComponent<TextMsgConfigProps> = ({
    userOption,
    upstreamOptions,
    dataSourceList,
    value,
    onChange
}) => {
    const disabledWithVersion = useIsDisabledWithVersion()

    return (
        <div style={{ marginTop: 8 }}>
            <SC.Item>
                <SC.Text>
                    消息内容
                    <SC.Text color="red" style={{ paddingLeft: 4 }}>
                        *
                    </SC.Text>
                </SC.Text>
                {/* <Input {...register('config.text.editorContent')} /> */}
                <NodeFieldPreview
                    innerTypes={getInputInnerTypeMatch('TEXT')}
                    disabled={disabledWithVersion}
                    autoHeight
                    userOption={userOption}
                    upstreamOptions={upstreamOptions}
                    value={value.text?.editorContent}
                    onBlur={editorContent => onChange({ ...value, text: { editorContent } })}
                    dataSourceList={dataSourceList}
                />
                {/* <NodeFieldPreview disabled={disabledWithVersion} autoHeight upstreamOptions={upstreamOptions} /> */}
                {/* <SC.Description>方案启动后，填入的文本内容，将被钉钉群机器人发出，请检查核对。</SC.Description> */}
            </SC.Item>
            <PersonConfig
                userOption={userOption}
                upstreamOptions={upstreamOptions}
                dataSourceList={dataSourceList}
                value={value}
                onChange={onChange}
            />
        </div>
    )
}
